<template>
  <div
   v-if="['contact_information','all_in_one_checkout'].includes($store.state.checkoutStep)"
    class="check-fclca-box"
    :class="{
      content_active: content_active,
      fclca_information: $store.state.checkoutStep == 'contact_information',
    }"
  >
    <div class="fclca-header">
      <h3 @click="screenWidth < 768 && toggle()" class="checkout_accent_color">
        RX Verification (US Customers Only)
        <span class="iconfont icon-cm-xia" v-show="!content_active"></span>
        <span class="iconfont icon-Group-" v-show="content_active"></span>
      </h3>
    </div>
    <div class="fclca-content" ref="fclcaContent">
      <p>
        According to the Fairness to Contact Lens Consumers Act (FCLCA), we need
        your valid prescription or eye doctor's contact information to verify
        it.
      </p>
      <div class="fclca-radio-box">
        <div
          class="fclca-radio-item"
          v-for="item in fclca_radio"
          :key="item.id"
          :class="{ 'radio-active': item.value == fclca.type }"
        >
          <label :for="item.id">{{ item.name }}</label>
          <input
            type="radio"
            name="type"
            :id="item.id"
            v-model="fclca.type"
            :value="item.value"
          />
          <span class="iconfont icon-ziyuan"> </span>
        </div>
      </div>
      <div class="fclca-form-box" v-show="fclca.type == 'email_my_doctor'">
        <v-fclcaDoc
          ref="fclcaDoc"
          :fclcaField="fclcaField"
          :certify="certify"
        ></v-fclcaDoc>
      </div>
      <div
        class="fclca-form-box"
        v-show="fclca.type == 'upload_eye_prescription'"
      >
        <v-fclcaUpload ref="fclcaUpload" :certify="certify" :fclca_gallery='fclca_gallery'></v-fclcaUpload>
      </div>
    </div>
  </div>
</template>
<script>
import vFclcaDoc from "./fclcaDoctor";
import vFclcaUpload from "./fclcaUpload.vue";
// import API from "../../../API";
export default {
  data() {
    return {
      fclca: {
        type: "email_me_later",
      },
      certify: false,
      fclca_gallery: [],
      fclcaField: {
        customer_name: "",
        doctor_name: "",
        clinic_name: "",
        clinic_email: "",
        confirm_email: "",
        clinic_contact_number: "",
        power_right: "",
        power_left: "",
        issued_at: "",
        expiration_at: "",
      },
      fclca_radio: [
        {
          name: "Email Me Later",
          id: "fclca-later",
          value: "email_me_later",
        },
        {
          name: "Email My Doctor",
          id: "fclca-doctor",
          value: "email_my_doctor",
        },
        {
          name: "Upload Eye Prescription",
          id: "fclca-prescription",
          value: "upload_eye_prescription",
        },
      ],
      content_active: true,
      screenWidth: 0,
      cart_hash: window.location.pathname.split("/")[2],
      checkout_arrive:null
    };
  },
  methods: {
    toggle() {
      this.content_active = !this.content_active;
      this.$(this.$refs.fclcaContent).slideToggle();
    },
    gather(payload) {
      if (payload && payload.checkout_arrive) {
        this.checkout_arrive = payload.checkout_arrive
      }
      this.$(this.$refs.fclcaContent).slideDown();
      //用来关闭按钮激活状态，若正常后续会在发请求时再开启激活
      this.bus.$emit("fclca-to-checkout", {
        fclca: "fail",
      });
      if (this.fclca.type == "email_my_doctor") {
        this.$refs.fclcaDoc.gether();
      } else if (this.fclca.type == "upload_eye_prescription") {
        this.$refs.fclcaUpload.gether();
      } else if (this.fclca.type == "email_me_later") {
        this.prescriptions();
      }
    },
    async prescriptions(payload) {
      try {
        //触发按钮激活状态
        this.bus.$emit("fclca-to-checkout", {
          fclca: "wait",
        });
        let { type } = this.fclca;
        if (!type) return;
        let copy_payload = null;
        this.$(this.$refs.fclcaContent).slideUp();
        if (type == "email_my_doctor") {
          copy_payload = { ...payload };
        } else if (type == "upload_eye_prescription") {
          copy_payload = [...payload];
        }
        let res = await this.$axios.post(API.prescriptions, {
          details: copy_payload ? copy_payload : undefined,
          type: this.fclca.type,
          cart_hash: this.cart_hash,
        });
        //处方api发完需要通知结账那边进行下一步；
        this.bus.$emit("fclca-to-checkout", {
          fclca: "success",
          checkout_arrive:this.checkout_arrive
        });
      } catch (error) {
        //处方api发完关闭等待状态
        this.bus.$emit("fclca-to-checkout", {
          fclca: "fail",
        });
      }
    },
    async get_fclca() {
      try {
        let res = await this.$axios.get(
          `/api/store/fclca/prescriptions/${this.cart_hash}`
        );
        if (res.data) {
          let { type, details } = res.data;
          if (!type) return;
          this.certify = true;
          this.fclca.type = type;
          if (details && Object.keys(details).length) {
            if (type == "upload_eye_prescription") {
              this.fclca_gallery = details;
            }
            if (type == "email_my_doctor") {
              for (const key in details) {
                this.fclcaField[key] = details[key];
              }
            }
          }
          console.log(details, "fclcaFieldfclcaField");
        }
      } catch (error) {}
    },
  },
  beforeMount() {
    //获取一下当前处方信息；
    this.get_fclca();
    //接受到页面传过来的事件后 会根据类型去子组件执行表单收集
    this.bus.$on("checkout-to-fclca", this.gather);
    //表单收集完成会触发下面这个事件,然后去发请求
    this.bus.$on("fclca-form-sent", this.prescriptions);
    //调用window.onresize监听浏览器窗口变化
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    console.log(this.screenWidth, "screenWidthscreenWidth");
  },
  beforeDestroy(){
    this.bus.$off("checkout-to-fclca");
    this.bus.$off("fclca-form-sent");
  },
  components: {
    vFclcaDoc,
    vFclcaUpload,
  },
};
</script>
<style scoped lang='scss'>
.check-fclca-box {
  margin-top: 40px;
  margin-bottom: 8px;
  @media screen and(max-width: 768px) {
    margin-top: 0;
    margin-bottom: 0;
  }
  .fclca-header {
    h3 {
      margin: 0;
      padding: 0;
      font-size: 18px;
      font-family: Roboto;
      font-weight: bold;
      color: #3a3a3a;
      line-height: 18px;
      @media screen and(min-width: 768px) {
        .iconfont {
          display: none !important;
        }
      }
    }
  }
  .fclca-content {
    @media screen and(min-width: 768px) {
      display: block !important;
      height: 100% !important;
    }
    & > p {
      margin: 11px 0 0 0;
      font-size: 16px;
      font-family: Roboto;
      font-weight: 400;
      color: #3a3a3a;
      line-height: 24px;
    }
    .fclca-radio-box {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      .fclca-radio-item {
        padding: 2px;
        border: 1px solid var(--main-btn-bg);
        flex: 1;
        margin-right: 30px;
        position: relative;
        border-radius: 2px;
        label {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          margin: 0;
          cursor: pointer;
          padding: 11px 5px;
          font-size: 14px;
          font-family: Roboto;
          font-weight: 400;
          color: var(--main-btn-bg);
          line-height: 18px;
        }
        input {
          display: none;
        }
        &:last-child {
          margin-right: 0;
        }
        .icon-ziyuan {
          display: none;
          position: absolute;
          width: 26px;
          height: 26px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          top: -11px;
          right: -13px;
          font-weight: 600;
          border: 2px solid #fff;
          background-color: var(--main-btn-bg);
          border-radius: 50%;
        }
      }
      .radio-active {
        border-radius: 2px;
        label {
          background-color: var(--main-btn-bg);
          color: var(--main-btn-tx);
        }
        .icon-ziyuan {
          display: inline-block;
        }
      }
    }
    .fclca-form-box {
      margin-top: 36px;
    }
  }
}
.fclca_information {
  @media screen and(min-width: 768px) {
    margin-bottom: 60px;
  }
}

@media screen and(max-width:768px) {
  .check-fclca-box {
    .fclca-header {
      h3 {
        font-size: 13px;
        padding: 20px 16px;
        margin: 0 -15px;
        font-weight: normal;
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        & > span {
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
    .fclca-content {
      margin-bottom: 30px;
      & > p {
        font-size: 13px;
      }
      .fclca-radio-box {
        .fclca-radio-item {
          margin-right: 13px;
          padding: 2px;
          label {
            font-size: 12px;
            padding: 3px 5px;
          }
        }
      }
    }
  }
  .content_active {
    .fclca-header {
      h3 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      }
    }
  }
}
</style>